import EventBus from "eventing-bus"
import { constants } from "../model"
import gsap from "gsap"

const viewEl = document.querySelector("#credits-view"),
  closeBtn = viewEl.querySelector(".close-btn"),
  containerEl = viewEl.querySelector(".container")

const showView = (bool) => {
  if (bool) {
    closeBtn.addEventListener("click", handleStageClicked)
    viewEl.classList.add("show")
    gsap.fromTo(containerEl, { scaleX: 0, scaleY: 0 }, { duration: 1.5, scaleX: 1, scaleY: 1, ease: "elastic.out(1,0.75)" })
    EventBus.publish(constants.PAUSE_THREE_TICK, true)
  } else {
    closeBtn.removeEventListener("click", handleStageClicked)
    viewEl.classList.remove("show")
    gsap.to(containerEl, { scaleX: 0, scaleY: 0 })
    EventBus.publish(constants.PAUSE_THREE_TICK, false)
  }
}

const handleStageClicked = () => {
  showView(false)
}

const handleCartButtonClick = () => {
  showView(true)
}

EventBus.on(constants.CART_BTN_PRESSED, handleCartButtonClick)
